class LanguagePicker {
    constructor(el) {
        this.el = el;
        this.currentButton = this.el.querySelector('.language-selector__current');
        this.currentLabel = this.el.querySelector('.language-selector__current-label');
        this.optionsContainer = this.el.querySelector('.language-selector__options');
        this.isOpen = false;
        this.options = [];

        this.currentButton.addEventListener('click', () => {
            this.toggleOpen();
        });

        this.setupLanguageOptions();
        this.setCurrentLanguage();

    }

    setupLanguageOptions() {
        for(const item of this.optionsContainer.querySelectorAll('.language-selector__option')) {
            this.options.push({
                labelAbbreviated: item.dataset.abrLabel,
                labelFull: item.innerHTML,
                url: item.getAttribute('href')
            });
        }

        console.log(this.options);
        console.log(window.location.hostname);
    }

    setCurrentLanguage() {
        const currentOptions = this.options.filter(option => {
            let hostname = (new URL(option.url)).hostname;
            if(hostname === window.location.hostname) {
                return true;
            }

            return false;
        });

        currentOptions.forEach(option => {

            this.currentLabel.innerHTML = option.labelAbbreviated;
        });



    }

    toggleOpen() {
        if(this.isOpen) {
            this.closeOptions();
        } else {
            this.openOptions();
        }
    }

    openOptions() {
        this.isOpen = true;
        this.optionsContainer.classList.add('language-selector__options--open');
    }

    closeOptions() {
        this.isOpen = false;
        this.optionsContainer.classList.remove('language-selector__options--open');
    }
}

export default LanguagePicker;